import { ChangeDetectionStrategy, Component, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@client/app/modules/translate.module';
import {
    AiRemediationsResponsibility,
    AI_REMEDIATIONS_RESPONSIBILITIES,
} from '@monsido/ng2/modules/models/api/interfaces/ai-remediations-responsibility.type';
import { MonSwitchModule } from '@monsido/angular-shared-components';

@Component({
    selector: 'remediation-companion-section',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, FormsModule, TranslateModule, MonSwitchModule],
    template: `
        <p class="help-block mt-0 pl-8" translate>
            Select your responsibilities so we can tailor remediation suggestions.
        </p>

        @for (role of roles; track role) {
            <div class="form-group row">
                <label class="col-sm-8 col-form-label text-bold text-right" [attr.for]="'remediation-companion-' + role">
                    {{ role | translate }}
                </label>
                <div class="col-sm-40">
                    <mon-switch
                        [name]="'remediation-companion-' + role"
                        [ngModel]="isSelected(role)"
                        (ngModelChange)="toggle(role, $event)">
                    </mon-switch>
                </div>
            </div>
        }

        <!-- gettext extraction anchor: keep these strings discoverable at build time -->
        @if (false) {
            <span translate>Visual Design</span>
            <span translate>UX Design</span>
            <span translate>Content Authoring</span>
            <span translate>Front-end Development</span>
        }
    `,
})
export class RemediationCompanionSectionComponent {
    value = model<AiRemediationsResponsibility[] | undefined>([]);

    readonly roles = AI_REMEDIATIONS_RESPONSIBILITIES;

    isSelected (role: AiRemediationsResponsibility): boolean {
        const currentValue = this.value();
        return Array.isArray(currentValue) && currentValue.includes(role);
    }

    toggle (role: AiRemediationsResponsibility, checked: boolean): void {
        const current = this.value() ?? [];
        const next = checked
            ? [...current, role]
            : current.filter(r => r !== role);
        this.value.set(next);
    }
}
